import React, { useState } from "react";
import { bmColors } from "./bmStyles";

// The portal's text list row: an open service, a section link. Buildings have
// their own item on the welcome page, since they lead with a photo.
//
// Deliberately plain — padding, a hairline underneath, a hover tint. Lists in
// this portal read as lists, so there is no card, no badge and no chevron.
export function PortalRow({ title, subtitle, onClick, isMobile }) {
  const [hover, setHover] = useState(false);
  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onTouchStart={() => setHover(true)}
      onTouchEnd={() => setHover(false)}
      style={{
        padding: isMobile ? "14px 4px" : "14px 8px",
        borderBottom: `1px solid ${bmColors.border}`,
        backgroundColor: hover ? "#f8fafc" : "transparent",
        cursor: "pointer",
      }}
    >
      <div style={{ fontSize: isMobile ? "15px" : "16px", color: bmColors.text }}>
        {title}
      </div>
      {subtitle && (
        <div style={{ fontSize: "13px", color: bmColors.slate, marginTop: "2px" }}>
          {subtitle}
        </div>
      )}
    </div>
  );
}

// The heading a group of rows sits under, and the hairline it starts with.
export function PortalSection({ title, isMobile, children }) {
  return (
    <div style={{ marginBottom: "24px" }}>
      <div
        style={{
          fontSize: "13px",
          fontWeight: "600",
          color: bmColors.slate,
          marginBottom: "4px",
          paddingLeft: isMobile ? "4px" : "8px",
        }}
      >
        {title}
      </div>
      <div style={{ borderTop: `1px solid ${bmColors.border}` }}>{children}</div>
    </div>
  );
}
